// components/MouvementFinancier/components/MouvementPagination.jsx
const MouvementPagination = ({ 
  currentPage, 
  totalPages, 
  totalCount,
  pageSize,
  onPageChange,
  onPageSizeChange 
}) => {
  // Éviter les valeurs invalides
  const safeTotalPages = Math.max(1, totalPages || 1);
  const safeCurrentPage = Math.min(Math.max(1, currentPage), safeTotalPages);

  /**
   * Génère les numéros de page avec points de suspension
   */
  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;
    
    if (safeTotalPages <= maxVisible) {
      for (let i = 1; i <= safeTotalPages; i++) pages.push(i);
    } else {
      pages.push(1);
      
      let start = Math.max(2, safeCurrentPage - 1);
      let end = Math.min(safeTotalPages - 1, safeCurrentPage + 1);
      
      if (safeCurrentPage <= 3) {
        end = 4;
      }
      
      if (safeCurrentPage >= safeTotalPages - 2) {
        start = safeTotalPages - 3;
      }
      
      if (start > 2) {
        pages.push('...');
      }
      
      for (let i = start; i <= end; i++) {
        if (i > 1 && i < safeTotalPages) {
          pages.push(i);
        }
      }
      
      if (end < safeTotalPages - 1) {
        pages.push('...');
      }
      
      if (safeTotalPages > 1) {
        pages.push(safeTotalPages);
      }
    }
    
    return pages;
  };

  const pageNumbers = getPageNumbers();
  const startItem = Math.min((safeCurrentPage - 1) * pageSize + 1, totalCount);
  const endItem = Math.min(safeCurrentPage * pageSize, totalCount);

  // Masquer la pagination s'il n'y a qu'une seule page
  if (safeTotalPages <= 1 && totalCount <= pageSize) {
    return (
      <div className="d-flex justify-content-between align-items-center p-2 bg-white rounded-2 shadow-sm">
        <div className="text-muted">
          Affichage de <strong>{startItem}</strong> à <strong>{endItem} </strong> 
          sur <strong> {totalCount}</strong> mouvements
        </div>
        <div className="d-flex align-items-center gap-2">
          <span className="text-muted me-2">Afficher :</span>
          <select 
            className="account-type-select"
            value={pageSize}
            onChange={(e) => onPageSizeChange(Number(e.target.value))}
            style={{ width: 'auto' }}
          >
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
          <span className="text-muted ms-2">par page</span>
        </div>
      </div>
    );
  }

  return (
    <nav className='mt-5'>
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3 p-4 bg-white rounded-3 shadow-sm">
        {/* Résumé */}
        <div className="text-muted mb-3 mb-md-0">
          Affichage de <strong>{startItem}</strong> à <strong>{endItem}</strong> 
          sur <strong>{totalCount}</strong> mouvements
        </div>

        {/* Sélecteur de taille de page */}
        <div className="d-flex align-items-center gap-2 mb-3 mb-md-0">
          <span className="text-muted me-2">Afficher :</span>
          <select 
            className="account-type-select"
            value={pageSize}
            onChange={(e) => onPageSizeChange(Number(e.target.value))}
            style={{ width: 'auto' }}
          >
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
          <span className="text-muted ms-2">par page</span>
        </div>

        {/* Pagination Bootstrap */}
        {safeTotalPages > 1 && (
          <ul className="pagination justify-content-center mb-0">
            {/* Bouton précédent */}
            <li className={`page-item ${safeCurrentPage === 1 ? 'disabled' : ''}`}>
              <button 
                className="page-link" 
                onClick={() => onPageChange(safeCurrentPage - 1)} 
                disabled={safeCurrentPage === 1}
                title="Page précédente"
              >
                <i className="fa-solid fa-chevron-left"></i>
              </button>
            </li>
            
            {/* Numéros de page avec points de suspension */}
            {pageNumbers.map((page, index) => {
              if (page === '...') {
                return (
                  <li key={`dots-${index}`} className="page-item disabled">
                    <span className="page-link">...</span>
                  </li>
                );
              }
              
              return (
                <li key={page} className={`page-item ${safeCurrentPage === page ? 'active' : ''}`}>
                  <button 
                    className="page-link" 
                    onClick={() => onPageChange(page)}
                  >
                    {page}
                  </button>
                </li>
              );
            })}
            
            {/* Bouton suivant */}
            <li className={`page-item ${safeCurrentPage === safeTotalPages ? 'disabled' : ''}`}>
              <button 
                className="page-link" 
                onClick={() => onPageChange(safeCurrentPage + 1)} 
                disabled={safeCurrentPage === safeTotalPages}
                title="Page suivante"
              >
                <i className="fa-solid fa-chevron-right"></i>
              </button>
            </li>
          </ul>
        )}
      </div>
    </nav>
  );
};

export default MouvementPagination;